"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_common_1 = require("@ryerson/frontend.common");

var uuid_1 = require("uuid");

var react_1 = require("@emotion/react");

var Checkbox = function Checkbox(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? (0, uuid_1.v4)() : _ref$id,
      value = _ref.value,
      name = _ref.name,
      className = _ref.className,
      label = _ref.label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$checked = _ref.checked,
      checked = _ref$checked === void 0 ? false : _ref$checked,
      onChange = _ref.onChange,
      onKeyPress = _ref.onKeyPress,
      dataTestId = _ref.dataTestId,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      inputRef = _ref.inputRef,
      tabIndex = _ref.tabIndex;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      borderColor = _theme$colors$primary.lightGray,
      selectedColor = _theme$colors$primary.primaryBrand,
      white = _theme$colors$primary.white;

  var _ref3 = (0, frontend_common_1.useDeviceDetect)(),
      isMobile = _ref3.isMobile;

  var controlSize = 20;
  var labelColor = disabled ? theme.colors[type].disable : theme.colors[type].label;
  var fontSize = size === "sm" ? "sm" : "md";
  name = name ? name : value;
  label = label ? label : value;
  var ControlContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tdisplay: flex;\n\t\tpadding: 5px 0;\n\t\tposition: relative;\n\t\tbox-sizing: border-box;\n\t\tcolor: ", ";\n\t"])), white);
  var HiddenCheckbox = styled_1.default.input(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\tposition: absolute;\n\t\twidth: 0;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\topacity: 0;\n\t\tz-index: 1;\n\t\t:checked + span {\n\t\t\t:before {\n\t\t\t\tborder-color: ", ";\n\t\t\t}\n\t\t\t:after {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t\t:hover + span {\n\t\t\t:before {\n\t\t\t\tborder-color: ", ";\n\t\t\t}\n\t\t}\n\t"])), isMobile ? white : selectedColor, disabled ? borderColor : selectedColor);
  var StyledCheckBox = styled_1.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\tcursor: ", ";\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tcolor: ", ";\n\t\t:before {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\twidth: ", "px;\n\t\t\theight: ", "px;\n\t\t\tborder-radius: 3px;\n\t\t\tcolor: ", ";\n\t\t\tbackground-color: ", ";\n\t\t\tborder: 1px solid ", ";\n\t\t}\n\t"])), disabled ? "default" : "pointer", white, controlSize, controlSize, theme.colors.primary.white, checked ? selectedColor : white, borderColor);
  var Label = styled_1.default.label(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\tposition: relative;\n\t\tcursor: ", ";\n\t"])), disabled ? "default" : "pointer");

  var handleKeyPress = function handleKeyPress(event) {
    if (!disabled) {
      var control = event.target;
      onKeyPress && onKeyPress(control.value, control.checked);
    }
  };

  var handleOnChange = function handleOnChange(event) {
    if (!disabled) {
      var control = event.target;
      onChange(control.value, control.checked);
    }
  };

  var labelStyle = (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\tpadding-left: 30px;\n\t\tline-height: 20px;\n\n\t\tcolor: ", ";\n\t\t", ";\n\t"])), labelColor, !disabled && "\n      :hover {\n        color: ".concat(selectedColor, ";\n      }\n    "));
  var IconContainer = styled_1.default.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\t\topacity: ", ";\n\t\tcursor: ", ";\n\t\tdisplay: inline-flex;\n\t\tposition: absolute;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\tmargin-left: 5px;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\theight: 12px;\n\t\twidth: 10px;\n\t\tcolor: white;\n\t\tbox-sizing: border-box;\n\t\tbackground-color: ", ";\n\t"])), checked ? 1 : 0, disabled ? "default" : "pointer", selectedColor);

  var CheckedIcon = function CheckedIcon() {
    return (0, jsx_runtime_1.jsx)("svg", {
      viewBox: "0 0 12 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: (0, jsx_runtime_1.jsx)("path", {
        d: "M1 9L4 12L11 5",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeMiterlimit: "10",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      })
    });
  };

  return (0, jsx_runtime_1.jsx)(ControlContainer, {
    tabIndex: tabIndex,
    "aria-disabled": disabled ? true : false,
    children: (0, jsx_runtime_1.jsxs)(Label, {
      id: id,
      children: [(0, jsx_runtime_1.jsx)(HiddenCheckbox, {
        type: "checkbox",
        id: id,
        name: name,
        value: value,
        checked: checked,
        onChange: handleOnChange,
        onKeyPress: handleKeyPress,
        className: className,
        "data-testid": dataTestId,
        tabIndex: -1,
        ref: inputRef
      }), (0, jsx_runtime_1.jsx)(StyledCheckBox, {
        children: (0, jsx_runtime_1.jsx)(IconContainer, {
          children: (0, jsx_runtime_1.jsx)(CheckedIcon, {})
        })
      }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        variant: "div",
        css: labelStyle,
        size: fontSize,
        children: label
      })]
    })
  });
};

Checkbox.displayName = "Checkbox";
exports.default = Checkbox;